export default {
    contentFilter: {
        title: 'Content Filter',
        description:
            'Maintain a global content whitelist, toggled per app build number (builder); enabled builds only show whitelisted content (feed, dramas, search, banner APIs).',
        versions: {
            title: 'Build Filter Switches',
            platform: {
                ios: 'iOS',
                android: 'Android',
            },
            count: '{total} builds · {enabled} active · {disabled} disabled',
            add: 'Add Build',
            enabled: 'Active',
            disabled: 'Disabled',
            empty: 'No builds',
        },
        modal: {
            createTitle: 'Add Build',
            platform: 'Platform',
            versionName: 'Builder No.',
            versionPlaceholder: 'Enter the builder number (digits only)',
            builderPattern: 'Builder number must be 1~10 digits',
            hint: 'The whitelist is enabled by default; the new build will only show whitelisted dramas',
            submit: 'Submit',
        },
        drama: {
            title: 'Drama ID Whitelist',
            bannerBadge: 'Banner {count}/5',
            totalBadge: '{count} total',
            addSearchPlaceholder: 'Search dramas by name or ID, then select from results',
            add: 'Add',
            searchPlaceholder: 'Search by ID or name',
            bannerHint: 'Dramas marked with ★ serve as App home banners, up to 5; only visible on builds with the whitelist enabled',
            empty: 'No whitelisted dramas',
            setBanner: 'Set as Banner',
            removeBanner: 'Remove Banner',
        },
        emptyWarning: '{count} active builds will see no dramas at all',
        removeConfirm: {
            title: 'Remove from whitelist',
            impact: '{count} active builds will stop seeing it immediately',
            bannerAlso: 'Its Banner mark will also be removed',
            confirm: 'Remove',
        },
        message: {
            loadFailed: 'Load failed',
            saveFailed: 'Save failed',
            removeSuccess: 'Removed',
            versionCreated: 'Build added',
            versionRemoved: 'Build deleted',
            noIdsWarning: 'Please select dramas from the search results first',
            createSuccess: 'Added {count} items',
            invalidSkipped: 'IDs not found and skipped: {ids}',
        },
    },
};
